import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSynchronizeArrowsSquare1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.195 7.62h1.52v16.76h-1.52Zm-1.53 16.76h1.53v1.52h-1.53Zm0-18.29h1.53v1.53h-1.53Zm-6.09-1.52h6.09v1.52h-6.09Zm0 21.33v-4.57h-1.53v1.53h-1.52v1.52h-1.52v1.52h-1.53v1.53h1.53v1.52h1.52v1.53h1.52V32h1.53v-4.57h6.09V25.9zm-6.1-18.28h1.53V6.09h1.52V4.57h-1.52V3.05h-1.53V1.52h-1.52V0h-1.52v4.57h-6.1v1.52h6.1v4.58h1.52V9.14h1.52zM5.335 25.9h6.1v1.53h-6.1Zm-1.52-1.52h1.52v1.52h-1.52Zm0-18.29h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M2.285 7.62h1.53v16.76h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSynchronizeArrowsSquare1
